import React from 'react';
import { useNavigate } from 'react-router-dom';

const LegalPageLayout = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        {/* Back button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-8 text-[rgba(255,255,255,0.5)] hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-[#3b82f6] rounded p-2"
          aria-label="Go back to previous page"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="text-[11px]">Back</span>
        </button>

        {/* Header */}
        <header className="mb-12">
          <h1 className="text-[24px] font-medium mb-4">{title}</h1>
          <p className="text-[11px] text-[rgba(255,255,255,0.5)]">
            Last updated: <time dateTime="2025-11-11">{lastUpdated}</time>
          </p>
        </header>

        {/* Content */}
        <article className="space-y-8 text-[rgba(255,255,255,0.8)] leading-relaxed">
          {children}
        </article>

        {/* Footer */}
        <footer className="mt-12 pt-8 border-t border-[rgba(255,255,255,0.1)]">
          <nav aria-label="Legal navigation">
            <ul className="flex flex-wrap gap-6 text-[10px]">
              <li>
                <a href="/privacy-policy" className="text-[#3b82f6] hover:text-[#60a5fa] transition-colors focus:outline-none focus:ring-2 focus:ring-[#3b82f6] rounded">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms-of-service" className="text-[#3b82f6] hover:text-[#60a5fa] transition-colors focus:outline-none focus:ring-2 focus:ring-[#3b82f6] rounded">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/accessibility-statement" className="text-[#3b82f6] hover:text-[#60a5fa] transition-colors focus:outline-none focus:ring-2 focus:ring-[#3b82f6] rounded">
                  Accessibility Statement
                </a>
              </li>
              <li>
                <button
                  onClick={() => {
                    localStorage.removeItem('dizee-cookie-consent');
                    window.location.reload();
                  }}
                  className="text-[#3b82f6] hover:text-[#60a5fa] transition-colors focus:outline-none focus:ring-2 focus:ring-[#3b82f6] rounded"
                >
                  Manage Cookie Preferences
                </button>
              </li>
            </ul>
          </nav>
        </footer>
      </div>
    </div>
  );
};

export const Section = ({ title, children }) => (
  <section>
    <h2 className="text-[16px] font-medium text-white mb-4">{title}</h2>
    {children}
  </section>
);

export const SubSection = ({ title, children }) => (
  <div className="mt-4">
    <h3 className="text-[14px] font-medium text-white mb-2">{title}</h3>
    {children}
  </div>
);

export const Paragraph = ({ children }) => (
  <p className="text-[11px] mt-4">{children}</p>
);

export const List = ({ items }) => (
  <ul className="list-disc list-inside ml-4 mt-2 space-y-2">
    {items.map((item, idx) => (
      <li key={idx} className="text-[11px]">{item}</li>
    ))}
  </ul>
);

export default LegalPageLayout;

